/** @file drawableAt: the node whose drawn part (impostor quad) lies under a viewport point, nearest first. */
import type { PickedNode } from './pickNode';
import { quadAt } from './quadAt';
import type { ViewportCtx } from './viewportCtx';

/**
 * Like the original's editor: a click on a part's picture picks the bone that carries it. The nearest drawn impostor
 * whose quad contains `p` (target pixels, `quadAt`) names its drawable's node; null when no part is under the point.
 */
export function drawableAt(ctx: ViewportCtx, p: readonly [number, number]): PickedNode | null {
  const puppet = ctx.puppet();
  const drawable = puppet?.bundle.puppet.drawables[quadAt(ctx, p)];
  if (puppet === null || drawable === undefined) return null;
  const index = puppet.names.indexOf(drawable.node);
  return index < 0 ? null : { name: drawable.node, index };
}
